const prefix = 'SUBSCRIPTIONS_';

// Sagas
export const UPDATE_SUBSCRIPTION = `${prefix}UPDATE_SUBSCRIPTION`;
